<dx-menu class="h-100" height="100%" [items]="menuLang">
    <a *dxTemplate="let item of 'linkTemplate'" [routerLink]="[]" [queryParams]="item.linkAttr" queryParamsHandling="merge">
        @if(item.icon){
            <i [ngClass]="item.icon"></i>
        }
        {{item.text}}
    </a>
</dx-menu>
